import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AppCommonModule } from '../common/common.module';
import { FormGroup, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { MyDatePickerModule } from 'mydatepicker';
import { MatSnackBarModule, MatAutocompleteModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatTooltipModule } from '@angular/material';
import { EmployeeRoutingModule } from './employee-routing.module';
import { DashboardEmployeeComponent } from './dashboard-employee/dashboard-employee.component';
import { DashboardEmployeeService } from './dashboard-employee/dashboard-employee.service';
import { TimesheetEntryComponent } from './timesheet-entry/timesheet-entry.component';
import { TimesheetEntryService } from './timesheet-entry/timesheet-entry.service';
import { UtilsModule } from '../utils/utils.module';
import { RequestUnlockDialogComponent } from './dashboard-employee/request-unlock-dialog/request-unlock-dialog.component';
import { EmployeeGuard } from './employee.guard';
import { ProjectComponent } from './project/project.component';
import { ProjectService } from './project/project.service';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { TimeSheetApprovalListComponent } from './time-sheet-approval-list/time-sheet-approval-list.component';
import { PopoverModule } from 'ngx-popover';
import { RejectedTimesheetDetailsComponent } from './rejected-timesheet-details/rejected-timesheet-details.component';

@NgModule({
  imports: [
    CommonModule,
    EmployeeRoutingModule,
    FormsModule,
    AppCommonModule,
    NgxPaginationModule,
    MyDatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    FilterPipeModule,
    PopoverModule,
    MatAutocompleteModule,
    MatTooltipModule
  ],
  exports: [MatSnackBarModule, MatAutocompleteModule, MatFormFieldModule, MatInputModule],
  entryComponents: [RequestUnlockDialogComponent],
  declarations: [
    DashboardEmployeeComponent,
    TimesheetEntryComponent,
    RequestUnlockDialogComponent,
    ProjectComponent,
    TimeSheetApprovalListComponent,
    RejectedTimesheetDetailsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DatePipe,
    DashboardEmployeeService,
    TimesheetEntryService,
    EmployeeGuard,
    ProjectService
  ]
})
export class EmployeeModule { }



// WEBPACK FOOTER //
// ./src/app/employee/employee.module.ts